import React from 'react'

interface LabelBoxProps {
  type: 'warning'
  children?: React.ReactNode
}

const LabelBox: React.FC<LabelBoxProps> = ({ type, children }) => {
  return (
    <div className="yz-label-box">
      <i className="icon-yuzu-circle-warning"/>
      {children}
    </div>
  )
}

export default LabelBox
